module.exports = "<p style=\"color:red\" >{{mensagem}}</p>"


//////////////////
// WEBPACK FOOTER
// C:/Disco D/Projetos/central-cliente/src/app/angular-base-ui/mensagem-validacao/mensagem-validacao.component.html
// module id = ../../../../../src/app/angular-base-ui/mensagem-validacao/mensagem-validacao.component.html
// module chunks = 1